import { useRoutes } from "react-router-dom";
import CreateCard from "../../Component/CreateCard.js"
import ProtectedRoute from "../RouteProtect.js"
import UserList from './User/View.js'
import Reporting from './RepTeamHistory/View.js'
import ReportingManager from './RepTeamHistory/Create.js'
import UserAdd from './User/Create.js'
import Permissions from './Permissions/Create.js'
import RoleMangment from './RoleMangment/routes.js'

import EditFormRoute from "../../Component/Forms/EditFormRoute"

const MarketingManagementCardArray = [
    {
        title: "User",
        path: "userList",
        auth: "user",
    },
    {
        title: "Role Mangment",
        path: "roleMangment",
        auth: "roleMangment",
    },
    {
        title: "Permissions",
        path: "permissions",
        auth: "permissions",
    },
    {
        title: "Reporting",
        path: "reporting",
        auth: "reporting",
    }
]
const MarketingManagementRoutesArray = [
    {
        path: "/",
        element: <CreateCard cardJson={[...MarketingManagementCardArray]} />
    },
    {
        path: "*",
        element: <>This is 404</>
    },
    {
        path: "userList/*",
        element: <UserList />
    },
    {
        path: "userList/addUser/*",
        element: <UserAdd />
    },
    {
        path: "userList/:id",
        element: <EditFormRoute />
    },
    {
        path: "permissions/*",
        element: <Permissions />
    },
    {
        path: "roleMangment/*",
        element: <RoleMangment />
    },
    {
        path: "reporting/*",
        element: <Reporting />
    },
    {
        path: "reporting/reportingManager*",
        element: <ReportingManager />
    }

]

export default function MarketingManagementRoutes() {
    return useRoutes(MarketingManagementRoutesArray)
}